<div *ngFor="let item of getJsonData(); let i = index" id="item_{{i}}">
  <div *ngIf="item.type == 'Phrase'" class="dragareaContain" (mouseover)="itemOver(item)">
    <app-ocr-plus-txt-phrase [item]="item"></app-ocr-plus-txt-phrase>
  </div>
  <div *ngIf="item.type == 'Table'" class="dragareaContain" (mouseover)="itemOver(item)">
    <app-ocr-plus-txt-tbl [item]="item"></app-ocr-plus-txt-tbl>
  </div>

</div>